import { Component, OnInit, Input, Output, EventEmitter,
  SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Component({
  selector: 'ngx-form-js-date',
  templateUrl: './form-js-date.component.html',
  styleUrls: ['./form-js-date.component.scss'],
})
export class FormJsDateComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() value: string | Date | number;
  @Input() disabled: boolean = false;
  @Input() empty: boolean = false;
  @Output() valueChange: EventEmitter<Date> = new EventEmitter<Date>();

  @ViewChild('d') datepickerRef;

  public dateValue: Date;
  constructor() {
    this.dateValue = new Date();
  }

  dateModel: NgbDateStruct;

  ngOnInit() {
    if (this.value != null && this.value !== '') {
      this.dateValue = new Date(this.value);
    } else if (+this.value === -1) {
      this.clear(false);
    }
    this.setModel(this.dateValue);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value && changes.value.currentValue) {
      if (+changes.value.currentValue === -1) {
        this.clear(false);
      } else {
        this.dateValue = new Date(changes.value.currentValue);
      }
      this.setModel(this.dateValue);
    }
  }

  setModel(date: Date = new Date()) {
    this.dateModel = date ? { day: date.getDate(), month: date.getMonth()+1, year: date.getFullYear() } : null;
  }

  emitDate(date: Date = new Date()) {
    this.value = date;
    this.valueChange.emit(date);
    this.close();
  }

  close() {
    this.datepickerRef.close();
  }

  // update(date: Date) {
  //   this.dateValue = date;
  //   this.valueChange.emit(this.dateValue);
  // }

  updateDate(ngbDate: NgbDateStruct) {
    const jsDate = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
    this.value = jsDate.toISOString();
    this.valueChange.emit(moment(jsDate).subtract('m', jsDate.getTimezoneOffset()).toDate());
  }

  clear(emit = true) {
    console.log('clear value');
    this.value = null;
    this.dateValue = null;
    this.dateModel = null;
    if (emit) this.valueChange.emit(null);
  }
}
